/** @jsx h */
import { component, h } from 'literaljs';
import { playBloop, playPop } from '../../utils/sounds';

function filterBySubstring(query, items) {
	if (!query) return items;
	const q = query.toLowerCase();
	return items.filter(item => {
		const text = `${item.name} ${item.description} ${item.tags?.join(' ') || ''}`.toLowerCase();
		return text.includes(q);
	});
}

export default component({
	name: 'SearchBar',
	props: ['onSearch', 'placeholder', 'value'],
	state: { query: '', focused: false },
	mounted() {
		if (this.props.value) {
			this.setState({ query: this.props.value });
		}
	},
	unmounted() {
		if (this._blurTimer) clearTimeout(this._blurTimer);
	},
	methods() {
		return {
			updateQuery(e) {
				const query = e.target.value;
				this.setState({ query });
				if (this.props.onSearch) {
					this.props.onSearch(query);
				}
			},
			handleKeyup(e) {
				// Fallback for browsers where input event doesn't fire properly
				const query = e.target.value;
				if (query !== this.getState().query) {
					this.setState({ query });
					if (this.props.onSearch) {
						this.props.onSearch(query);
					}
				}
			},
			clear() {
				playPop();
				this.setState({ query: '' });
				if (this.props.onSearch) {
					this.props.onSearch('');
				}
				const input = this.base.querySelector('.search-input');
				if (input) input.focus();
			},
			focus() {
				this.setState({ focused: true });
			},
			blur() {
				this._blurTimer = setTimeout(() => this.setState({ focused: false }), 200);
			}
		};
	},
	render() {
		const state = this.getState() || {};
		const query = state.query || '';
		const focused = !!state.focused;
		const hasValue = query.length > 0;

		return (
			<div class={"search-bar" + (focused ? " -focused" : "")}>
				<div class="search-icon">🔍</div>
				<input
					id={this.props.id || 'api-search'}
					type="text"
					class="search-input"
					placeholder={this.props.placeholder || "Search API..."}
					aria-label={this.props.placeholder || "Search API"}
					value={query}
					events={{
						input: (e) => this.updateQuery(e),
						keyup: (e) => this.handleKeyup(e),
						focus: () => this.focus(),
						blur: () => this.blur()
					}}
				/>
			{hasValue && (
				<button
					class="search-clear"
					events={{ click: () => this.clear() }}
					title="Clear search"
				>
					✕
				</button>
			)}
			</div>
		);
	}
});
